import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

import { actionOnMessage } from '@skynet/data-ws-mm';
import { parseResponse } from '@skynet/data-ws-core';
import { listen as listenLoans } from 'src/store/loans/actions';
import { LoansSummaryCommands } from './types';
import type { LoansSummaryState, JsonLoansSummarySuccess, LoansSummaryTimeFrame } from './types';

const allowedCommands = Object.values(LoansSummaryCommands);

export const INITIAL_SUMMARY_FILTER_STATE = {
  sortKey: 'created_asc',
  searchValue: '',
};

export const initialState: LoansSummaryState = {
  data: null,
  status: 'pending',
  error: null,
  timeFrame: '24h',
  ...INITIAL_SUMMARY_FILTER_STATE,
};

const loansSummarySlice = createSlice({
  name: 'loansSummary',
  initialState,
  reducers: {
    setSearchValue(state, action: PayloadAction<string>) {
      state.searchValue = action.payload;
    },
    setSortKey(state, action: PayloadAction<string>) {
      state.sortKey = action.payload;
    },
    setTimeFrame(state, action: PayloadAction<LoansSummaryTimeFrame>) {
      state.timeFrame = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(listenLoans, (state, action) => {
      const { section } = action.payload;
      const { isInitCall } = action.meta;
      if (isInitCall && section === 'summary') {
        state.status = 'pending';
      }
    });

    builder.addCase(actionOnMessage, (state, action) => {
      const { json, skipProcessing, error, errorCommand } = parseResponse(
        action.payload,
        allowedCommands,
      );

      if (skipProcessing || !json) return;

      console.debug(
        `loans/funds/processing ${actionOnMessage.toString()}`,
        action,
        allowedCommands,
      );

      const { command } = json;

      if (error) {
        state.error = error;

        switch (errorCommand) {
          case undefined:
          default:
        }

        return;
      }

      if (command === LoansSummaryCommands.LoansSummary) {
        const { loans } = json as JsonLoansSummarySuccess;
        state.status = 'success';
        state.data = loans;
      }
    });
  },
});

export const loanTradingViewActions = { ...loansSummarySlice.actions };

export default loansSummarySlice.reducer;
